export default __webpack_public_path__ + "static/media/soloExerciseBtn.e56f10c2.png";